<template lang="pug">
#donut-grafico
    DonutGrafico(
        v-if='configuracoes',
        type='donut',
        :height='height',
        :options='options',
        :series='series',
        ref='donutChart'
    )
</template>

<script>
import ApexCharts from 'vue-apexcharts';

export default {
    name: 'GraficoDonut',
    props: {
        dados: {
            type: Array,
            default: () => []
        },
        height: {
            type: String,
            default: '200'
        },
        configuracoes: {
            type: Object
        }
    },
    components: {
        DonutGrafico: ApexCharts
    },
    data() {
        return {
            series: [],
            options: {}
        };
    },
    methods: {
        updateGrafico() {
            if (this.configuracoes && this.dados) {
                this.series = this.dados;
                this.options = this.configuracoes;
            }
        }
    },
    mounted() {
        this.updateGrafico();
    },
    watch: {
        configuracoes() {
            this.updateGrafico();
        }
    }
};
</script>

<style>
#donut-grafico {
    height: 100% !important;
    width: 100%;
}
</style>
